import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import Hero from "./sections/Hero";
import Coreproducts from "./sections/Coreproducts";
import Applications from "./sections/Applications";
import SupplySupport from "./sections/SupplySupport";
import Inquiry from "./sections/Inquiry";
export default function HomePage() {
  return <div>
      <Navigation />
      <Hero />
      <Coreproducts />
      <Applications />
      <SupplySupport />
      <Inquiry />
      <Footer />
    </div>;
}